var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorialicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77798 7.41651L4.05381 4.85753C3.77469 4.66598 3.41583 4.89345 3.41583 5.26158V10.3795C3.41583 10.7477 3.77469 10.9751 4.05381 10.7836L7.77798 8.22461C8.04646 8.03905 8.04646 7.60207 7.77798 7.41651Z",
    fill: "#00A0DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2025 1.86461V0H11.9089C11.3187 0 10.7977 0.347183 10.5 0.870951C10.2023 0.347183 9.68127 0 9.09114 0H0.797468V15.3838V1.86461H0V16.2817H8.89177C8.95291 16.6887 9.26392 17 9.64405 17H11.356C11.7361 17 12.0471 16.6887 12.1082 16.2817H21V1.86461H20.2025ZM10.2342 14.7852H1.32911V0.598592H9.09114C9.72114 0.598592 10.2342 1.17623 10.2342 1.88556V14.7852ZM19.6709 14.7852H10.7658V1.88556C10.7658 1.17623 11.2789 0.598592 11.9089 0.598592H19.6709V14.7852Z",
    fill: "#00A0DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4215 2.58289H12.0152V2.88218H18.4215V2.58289Z",
    fill: "#00A0DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4215 3.7113H12.0152V4.0106H18.4215V3.7113Z",
    fill: "#00A0DF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4215 4.84253H12.0152V5.14183H18.4215V4.84253Z",
    fill: "#00A0DF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4215 5.974H12.0152V6.27329H18.4215V5.974Z",
    fill: "#00A0DF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4215 7.10522H12.0152V7.40452H18.4215V7.10522Z",
    fill: "#00A0DF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4215 8.23669H12.0152V8.53599H18.4215V8.23669Z",
    fill: "#00A0DF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4215 9.36792H12.0152V9.66722H18.4215V9.36792Z",
    fill: "#00A0DF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4215 10.4993H12.0152V10.7986H18.4215V10.4993Z",
    fill: "#00A0DF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4215 11.6306H12.0152V11.9299H18.4215V11.6306Z",
    fill: "#00A0DF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4215 12.762H12.0152V13.0613H18.4215V12.762Z",
    fill: "#00A0DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialicon);
export default __webpack_public_path__ + "static/media/tutorialicon.09b9ead988aaec7d4f07fa17cb67a376.svg";
export { ForwardRef as ReactComponent };